import RtHomeMain from "./RtHomeMain";
import RtHomeTopBar from "./RtHomeTopBar";

export default {
  Main: RtHomeMain,
  TopBar: RtHomeTopBar,
};
